
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ejAeh", function(module, exports) {
/* eslint-disable require-unicode-regexp */ const $111bb5a84f82538f$export$e79189cdb9940bc5 = ({ cloudId: cloudId, parentId: parentId, product: product, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${product}/${parentId}/${resourceId}`;
};
const $111bb5a84f82538f$export$92a2331f8a9ed841 = ({ cloudId: cloudId, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${resourceId}`;
};
const $111bb5a84f82538f$export$3f0878b0afe5a2c0 = (ari)=>{
    const match = ari.match(/ari:cloud:blocks:[^:]+:synced-block\/([a-zA-Z0-9-]+)/);
    if (match?.[1]) return match[1];
    throw new Error(`Invalid block ARI: ${ari}`);
};
const $111bb5a84f82538f$export$c10656f449ea0fb5 = (ari)=>{
    const jiraMatch = ari?.search(/ari:cloud:jira:.*/);
    if (jiraMatch !== -1) return 'jira-work-item';
    const confluenceMatch = ari?.search(/ari:cloud:confluence:.*/);
    if (confluenceMatch !== -1) return 'confluence-page';
    return undefined;
};
module.exports["generateBlockAri"] = $111bb5a84f82538f$export$e79189cdb9940bc5;
module.exports["generateBlockAriFromReference"] = $111bb5a84f82538f$export$92a2331f8a9ed841;
module.exports["getProductFromSourceAri"] = $111bb5a84f82538f$export$c10656f449ea0fb5;

});

parcelRegister("gtauf", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $5a9379de970b4a33$export$aafb32b192c8228c = (node)=>{
    return {
        blockInstanceId: node.attrs.localId,
        content: node.content.toJSON(),
        resourceId: node.attrs.resourceId
    };
};
const $5a9379de970b4a33$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $5a9379de970b4a33$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $5a9379de970b4a33$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $5a9379de970b4a33$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $5a9379de970b4a33$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $5a9379de970b4a33$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$5a9379de970b4a33$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined);
};
const $5a9379de970b4a33$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match(/^(confluence-page|jira-work-item)\/([^/]+)/);
    if (match?.[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
const $5a9379de970b4a33$export$4c6687d128f55da5 = (contentUpdatedAt)=>{
    if (typeof contentUpdatedAt === 'number') try {
        return new Date(contentUpdatedAt).toISOString();
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $5a9379de970b4a33$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $5a9379de970b4a33$export$c5b34fb9069ebb1d;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $5a9379de970b4a33$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $5a9379de970b4a33$export$18b85168a73dad03;
module.exports["getContentIdAndProductFromResourceId"] = $5a9379de970b4a33$export$2cf4a74c3e18f31a;
module.exports["convertContentUpdatedAt"] = $5a9379de970b4a33$export$4c6687d128f55da5;

});

parcelRegister("awHlv", function(module, exports) {
var $14957aea32c8ee8e$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    SyncBlockError["Offline"] = "offline";
    SyncBlockError["Unpublished"] = "unpublished";
    // request was aborted, typically due to client timeout
    SyncBlockError["Aborted"] = "aborted";
    return SyncBlockError;
}({});
module.exports["SyncBlockError"] = $14957aea32c8ee8e$export$686dd843fdf311d4;

});

parcelRegister("cFpEg", function(module, exports) {

var $d925B = parcelRequire("d925B");

const $22be2fac1f3375a4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $22be2fac1f3375a4$export$999ed1af1b20ac2d = (actionSubjectId, error, resourceId)=>({
        action: (0, $d925B.ACTION).ERROR,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error,
            ...resourceId && {
                resourceId: resourceId
            }
        }
    });
const $22be2fac1f3375a4$export$94dcd08406353dba = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId);
const $22be2fac1f3375a4$export$c5131f589148b9d3 = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error, resourceId);
const $22be2fac1f3375a4$export$adc2363832f8735d = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error, resourceId);
const $22be2fac1f3375a4$export$154595d209a77913 = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error, resourceId);
const $22be2fac1f3375a4$export$5d2f0c264cf49280 = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error, resourceId);
const $22be2fac1f3375a4$export$cd0aaab38ff32ec2 = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error, resourceId);
const $22be2fac1f3375a4$export$e40ed1768baf5d1e = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error, resourceId);
const $22be2fac1f3375a4$export$ebf3ba305f3f0e1a = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH_REFERENCES, error, resourceId);
const $22be2fac1f3375a4$export$b20c56c32ea6ad76 = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $d925B.ACTION).FETCHED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            blockInstanceId: blockInstanceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $22be2fac1f3375a4$export$5b8e0915870366d0 = (resourceId)=>{
    return {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).BODIED_SYNCED_BLOCK,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            resourceId: resourceId
        }
    };
};
const $22be2fac1f3375a4$export$dd6ad6471c8fade8 = (resourceId)=>({
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId
        }
    });
const $22be2fac1f3375a4$export$f2b4214fae56af83 = (resourceId, hasReference)=>({
        action: (0, $d925B.ACTION).UPDATED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...hasReference !== undefined && {
                hasReference: hasReference
            }
        }
    });
const $22be2fac1f3375a4$export$2283f5d682476cde = (resourceId)=>({
        action: (0, $d925B.ACTION).DELETED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId
        }
    });
module.exports["stringifyError"] = $22be2fac1f3375a4$export$7fc2c997455452c8;
module.exports["fetchErrorPayload"] = $22be2fac1f3375a4$export$94dcd08406353dba;
module.exports["getSourceInfoErrorPayload"] = $22be2fac1f3375a4$export$c5131f589148b9d3;
module.exports["updateErrorPayload"] = $22be2fac1f3375a4$export$adc2363832f8735d;
module.exports["updateReferenceErrorPayload"] = $22be2fac1f3375a4$export$154595d209a77913;
module.exports["createErrorPayload"] = $22be2fac1f3375a4$export$5d2f0c264cf49280;
module.exports["deleteErrorPayload"] = $22be2fac1f3375a4$export$cd0aaab38ff32ec2;
module.exports["updateCacheErrorPayload"] = $22be2fac1f3375a4$export$e40ed1768baf5d1e;
module.exports["fetchReferencesErrorPayload"] = $22be2fac1f3375a4$export$ebf3ba305f3f0e1a;
module.exports["fetchSuccessPayload"] = $22be2fac1f3375a4$export$b20c56c32ea6ad76;
module.exports["createSuccessPayload"] = $22be2fac1f3375a4$export$5b8e0915870366d0;
module.exports["updateSuccessPayload"] = $22be2fac1f3375a4$export$f2b4214fae56af83;
module.exports["deleteSuccessPayload"] = $22be2fac1f3375a4$export$2283f5d682476cde;

});

parcelRegister("47N43", function(module, exports) {

var $6RJVA = parcelRequire("6RJVA");

const $f989ba18ccabbf74$var$isSyncBlockProduct = (product)=>{
    return (0, $6RJVA.SYNC_BLOCK_PRODUCTS).includes(product);
};
const $f989ba18ccabbf74$export$8aafdd7901afa57f = (resourceId)=>{
    if (!resourceId) return undefined;
    const [product, contentId, uuid, ...rest] = resourceId.split('/');
    // invalid if any part is missing or there are extra parts
    if (!product || !contentId || !uuid || rest.length > 0) return undefined;
    // invalid if product is not recognized
    if (!$f989ba18ccabbf74$var$isSyncBlockProduct(product)) return undefined;
    return {
        product: product,
        contentId: contentId,
        uuid: uuid
    };
};
const $f989ba18ccabbf74$export$cf5895b3b46faf63 = (product, contentId, uuid)=>{
    return `${product}/${contentId}/${uuid}`;
};
module.exports["parseResourceId"] = $f989ba18ccabbf74$export$8aafdd7901afa57f;
module.exports["createResourceIdForReference"] = $f989ba18ccabbf74$export$cf5895b3b46faf63;

});

parcelRegister("6RJVA", function(module, exports) {
const $ccfe16213375d02d$export$c05408ef703373ad = [
    'confluence-page',
    'jira-work-item'
];
module.exports["SYNC_BLOCK_PRODUCTS"] = $ccfe16213375d02d$export$c05408ef703373ad;

});

parcelRegister("f8eu7", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ /**
 * The type of the Confluence page
 */ const $ff6ec2d844d0271f$export$3c54cf45dfed84ea = ({ pageId: pageId, cloudId: cloudId, pageType: pageType })=>{
    return `ari:cloud:confluence:${cloudId}:${pageType}/${pageId}`;
};
const $ff6ec2d844d0271f$export$2ee4e689bde04de2 = ({ ari: ari })=>{
    const match = ari.match(/ari:cloud:confluence:[^:]+:(page|blogpost)\/(\d+)/);
    if (match?.[2]) return {
        type: match[1],
        id: match[2]
    };
    throw new Error(`Invalid page ARI: ${ari}`);
};
module.exports["getConfluencePageAri"] = $ff6ec2d844d0271f$export$3c54cf45dfed84ea;
module.exports["getPageIdAndTypeFromConfluencePageAri"] = $ff6ec2d844d0271f$export$2ee4e689bde04de2;

});

parcelRegister("i5WUp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $1Whri = parcelRequire("1Whri");


var $c6GJD = parcelRequire("c6GJD");


var $dpPtd = parcelRequire("dpPtd");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $2Rith = parcelRequire("2Rith");

var $fYQcF = parcelRequire("fYQcF");


var $9Rf00 = parcelRequire("9Rf00");

var $au4KV = parcelRequire("au4KV");


var $gWF6I = parcelRequire("gWF6I");


var $9NDUe = parcelRequire("9NDUe");

var $2Gu9D = parcelRequire("2Gu9D");


var $in8wv = parcelRequire("in8wv");


var $kt1Xc = parcelRequire("kt1Xc");


var $2UyBL = parcelRequire("2UyBL");

const $990b0c00f1a7800f$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $990b0c00f1a7800f$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $990b0c00f1a7800f$var$DEFAULT_MAX_LINES = 4;
const $990b0c00f1a7800f$var$styles = {
    container: "_11c8wadc"
};
const $990b0c00f1a7800f$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $990b0c00f1a7800f$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $990b0c00f1a7800f$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true,
        skipAISessionValidation: true
    });
const $990b0c00f1a7800f$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
        config: $990b0c00f1a7800f$var$getAnalyticsConfig(props),
        children: /*#__PURE__*/ (0, $l998X.jsx)($990b0c00f1a7800f$export$ac90160f7ae1e32f, {
            ...props
        })
    });
};
const $990b0c00f1a7800f$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $990b0c00f1a7800f$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $irOoi.useQueryLoader)((0, $2UyBL.default));
    const isLoadingRef = (0, $42omo.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $2Gu9D.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $990b0c00f1a7800f$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $dh538.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $42omo.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        };
    // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $in8wv.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($990b0c00f1a7800f$var$styles.container),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $au4KV.AIStreamLoading), {}),
                children: queryRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $kt1Xc.AISnippetLoader), {
                    queryRef: queryRef,
                    fallbackText: fallbackText,
                    contentId: contentId,
                    source: source,
                    isHidden: isHidden,
                    maxLines: maxLines,
                    showFooter: showFooter,
                    showAwareness: showAwareness
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $au4KV.AIStreamLoading), {})
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
        children: isEnabledForJira ? content : /*#__PURE__*/ (0, $l998X.jsx)((0, $9Rf00.AIFeedbackPropertiesProvider), {
            entrypointId: $990b0c00f1a7800f$var$SNIPPET_ENTRYPOINT_ID,
            userId: userId,
            displayName: displayName,
            children: content
        })
    });
};
const $990b0c00f1a7800f$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.RelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($990b0c00f1a7800f$export$1b2af18ca4bb327b, {
            ...props
        })
    });
};
module.exports["AISnippetWithRelayEnvironment"] = $990b0c00f1a7800f$export$c9a07cebec67e951;

});

parcelRegister("9Rf00", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");

const $a07f007de41f1483$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $a07f007de41f1483$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $a07f007de41f1483$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $a07f007de41f1483$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $8C5kA.default)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $42omo.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($a07f007de41f1483$export$f906c21bacdb2d8e.Provider, {
        value: contextValue,
        children: children
    });
};
const $a07f007de41f1483$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $42omo.useContext)($a07f007de41f1483$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};
module.exports["AIFeedbackPropertiesProvider"] = $a07f007de41f1483$export$e9e654940dee103b;
module.exports["useAIFeedbackProperties"] = $a07f007de41f1483$export$ff3deb4415ee32e3;

});

parcelRegister("au4KV", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $igbBp = parcelRequire("igbBp");

const $fe7ceaa3509ef4fa$var$styles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle'
});
const $fe7ceaa3509ef4fa$var$i18n = (0, $cgtv4.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        padding: padding,
        xcss: $fe7ceaa3509ef4fa$var$styles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.025",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $igbBp.GeneratingStreamAnimation), {
                    alt: formatMessage($fe7ceaa3509ef4fa$var$i18n.generatingSummaryAnimationAlt)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$fe7ceaa3509ef4fa$var$i18n.generatingSummaryText
                })
            ]
        })
    });
};
module.exports["AIStreamLoading"] = $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef;

});

parcelRegister("igbBp", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $dd45fdb3e38904f6$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "#0C66E4",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "#1D7AFC",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "#388BFF",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
module.exports["GeneratingStreamAnimation"] = $dd45fdb3e38904f6$export$3709887a1be0e305;

});

parcelRegister("2Gu9D", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $42omo = parcelRequire("42omo");


var $5aVN7 = parcelRequire("5aVN7");

const $b5fd5f50ef335781$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $42omo.useRef)(new (0, $5aVN7.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $42omo.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $42omo.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $42omo.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $42omo.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $42omo.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $b5fd5f50ef335781$export$fade2d05a6320d49;

});

parcelRegister("in8wv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $e6pbP = parcelRequire("e6pbP");


var $c6GJD = parcelRequire("c6GJD");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $fYQcF = parcelRequire("fYQcF");


var $aFC6o = parcelRequire("aFC6o");

var $iuafG = parcelRequire("iuafG");

var $aXh2V = parcelRequire("aXh2V");


var $fXbFR = parcelRequire("fXbFR");

const $b015c3cc5e677900$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $b015c3cc5e677900$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $b015c3cc5e677900$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines, renderAsMarkdown: renderAsMarkdown = true })=>{
    const ref = (0, $42omo.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $42omo.useRef)(text);
    const isExperimentEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-fixes-1025', 'isEnabled', false);
    const isFeedbackEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-experiment-feedback', 'isEnabled', false);
    const handleLikeClicked = (0, $42omo.useCallback)(()=>{
        trackAIFeedbackSubmit('up');
    }, [
        trackAIFeedbackSubmit
    ]);
    const handleDislikeClicked = (0, $42omo.useCallback)(()=>{
        trackAIFeedbackSubmit('down');
    }, [
        trackAIFeedbackSubmit
    ]);
    (0, $42omo.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $b015c3cc5e677900$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.100",
        ref: ref,
        children: [
            showAwareness && /*#__PURE__*/ (0, $l998X.jsx)((0, $aFC6o.AIAwareness), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                maxLines: maxLines,
                children: renderAsMarkdown ? isExperimentEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
                    options: {
                        disableParsingRawHTML: true
                    },
                    children: $b015c3cc5e677900$var$sanitizeMarkdown(text || '')
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
                    children: text || ''
                }) : text || ''
            }),
            showFooter && text && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iuafG.AIDisclaimer), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $aXh2V.AIFeedbackComponent), {
                        contentId: contentId,
                        onLikeClicked: isFeedbackEnabled ? handleLikeClicked : undefined,
                        onDislikeClicked: isFeedbackEnabled ? handleDislikeClicked : undefined
                    })
                ]
            })
        ]
    });
};
module.exports["AISnippetContent"] = $b015c3cc5e677900$export$3cf37822a11d3ff3;

});

parcelRegister("aFC6o", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $lAFHW = parcelRequire("lAFHW");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $eLAh6 = parcelRequire("eLAh6");

const $902b2990c09c9892$var$styles = {
    text: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $902b2990c09c9892$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $eLAh6.i18n).rovoAwarenessMessage,
        define: (0, $eLAh6.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($902b2990c09c9892$var$styles.text),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                    size: "xxsmall",
                    appearance: "brand",
                    shouldUseNewLogoDesign: true
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    children: formatMessage(message)
                })
            ]
        })
    });
};
module.exports["AIAwareness"] = $902b2990c09c9892$export$fde99ed387d90f1;

});

parcelRegister("eLAh6", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $8e99185ad20025a1$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    rovoAwarenessMessage: {
        id: "ai-awareness.rovoAwarenessMessage",
        defaultMessage: "Summary by Rovo"
    },
    rovoAwarenessDefineMessage: {
        id: "ai-awareness-define.message",
        defaultMessage: "Definition by Rovo"
    }
});
module.exports["i18n"] = $8e99185ad20025a1$export$a7357cdd1f0b0168;

});

parcelRegister("iuafG", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $2Nwuj = parcelRequire("2Nwuj");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $fSglY = parcelRequire("fSglY");

const $8fdbd961e8c69c33$var$AI_DISCLAIMER_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $8fdbd961e8c69c33$var$styles = {
    text: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $8fdbd961e8c69c33$export$e0542ba0c737fe5c = ({ onLinkClick: onLinkClick, withLink: withLink = false })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const disclaimerContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest",
        children: formatMessage((0, $fSglY.i18n).disclaimerMessage)
    });
    if (withLink) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        appearance: "subtle",
        href: $8fdbd961e8c69c33$var$AI_DISCLAIMER_LINK,
        target: "_blank",
        onClick: onLinkClick,
        children: disclaimerContent
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($8fdbd961e8c69c33$var$styles.text),
        children: disclaimerContent
    });
};
module.exports["AIDisclaimer"] = $8fdbd961e8c69c33$export$e0542ba0c737fe5c;

});

parcelRegister("fSglY", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $fe37a92cb7b3dd3c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    disclaimerMessage: {
        id: "ai-disclaimer.disclaimerMessage",
        defaultMessage: "Uses AI. Verify results."
    }
});
module.exports["i18n"] = $fe37a92cb7b3dd3c$export$a7357cdd1f0b0168;

});

parcelRegister("aXh2V", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $eEA8O = parcelRequire("eEA8O");


var $biiXa = parcelRequire("biiXa");


var $dpPtd = parcelRequire("dpPtd");


var $3sFtD = parcelRequire("3sFtD");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $6fnsQ = parcelRequire("6fnsQ");


var $3gadb = parcelRequire("3gadb");


var $9Rf00 = parcelRequire("9Rf00");


var $aFwxm = parcelRequire("aFwxm");

const $00b0d3bf57a2c2c6$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $00b0d3bf57a2c2c6$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $00b0d3bf57a2c2c6$var$i18n = (0, $cgtv4.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    improveAtlassianTextAppify: {
        id: "quick-summary.feedback.improve-atlassian-appify",
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $00b0d3bf57a2c2c6$var$PrivacyPolicyLink = ({ link: link })=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$00b0d3bf57a2c2c6$var$i18n.privacyPolicyLink
        })
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $l998X.jsx)("a", {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$00b0d3bf57a2c2c6$var$i18n.privacyPolicyLink
        })
    });
const $00b0d3bf57a2c2c6$var$ResearchGroupLink = ({ link: link })=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$00b0d3bf57a2c2c6$var$i18n.researchGroupLink
        })
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $l998X.jsx)("a", {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$00b0d3bf57a2c2c6$var$i18n.researchGroupLink
        })
    });
const $00b0d3bf57a2c2c6$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...$00b0d3bf57a2c2c6$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$PrivacyPolicyLink, {
                link: $00b0d3bf57a2c2c6$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $00b0d3bf57a2c2c6$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $dh538.fg)('product-terminology-refresh') ? $00b0d3bf57a2c2c6$var$i18n.improveAtlassianTextAppify : $00b0d3bf57a2c2c6$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$ResearchGroupLink, {
                link: $00b0d3bf57a2c2c6$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $00b0d3bf57a2c2c6$var$DislikeIconWrapperXCSS = (0, $ecnYn.xcss)({
    transform: 'rotate(180deg)'
});
const $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS = (0, $ecnYn.xcss)({
    height: '24px',
    width: '24px'
});
const $00b0d3bf57a2c2c6$export$f9f34317e5bc3551 = ({ contentId: contentId, onLikeClicked: onLikeClicked, onDislikeClicked: onDislikeClicked })=>{
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $42omo.useState)(false);
    const feedbackCollectorProperties = (0, $9Rf00.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $42omo.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($00b0d3bf57a2c2c6$var$i18n.flagTitle),
            description: formatMessage($00b0d3bf57a2c2c6$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                spacing: "spacious",
                color: `var(--ds-icon-success, ${(0, $6fnsQ.G300)})`,
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const handleLikeClicked = ()=>{
        onLikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const handleDislikeClicked = ()=>{
        onDislikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        role: "none",
        onClick: (e)=>e.stopPropagation(),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    hideTooltipOnMouseDown: true,
                    content: formatMessage($00b0d3bf57a2c2c6$var$i18n.likeTooltip),
                    position: "top",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "subtle",
                            "aria-label": formatMessage($00b0d3bf57a2c2c6$var$i18n.likeTooltip),
                            spacing: "none",
                            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $aFwxm.ThumbIcon), {
                                isSelected: hasGoodFeedbackBeenSubmitted
                            }),
                            onClick: handleLikeClicked,
                            testId: "feedback-like-button",
                            isDisabled: hasGoodFeedbackBeenSubmitted
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    hideTooltipOnMouseDown: true,
                    content: formatMessage($00b0d3bf57a2c2c6$var$i18n.dislikeTooltip),
                    position: "top",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "subtle",
                            "aria-label": formatMessage($00b0d3bf57a2c2c6$var$i18n.dislikeTooltip),
                            spacing: "none",
                            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: $00b0d3bf57a2c2c6$var$DislikeIconWrapperXCSS,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aFwxm.ThumbIcon), {
                                    isSelected: hasBadFeedbackBeenSubmitted
                                })
                            }),
                            onClick: handleDislikeClicked,
                            testId: "feedback-dislike-button",
                            isDisabled: hasBadFeedbackBeenSubmitted
                        })
                    })
                }),
                isFeedbackOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $biiXa.default), {
                    locale: feedbackCollectorProperties.locale,
                    onSubmit: onFeedbackSubmit,
                    onClose: ()=>setIsFeedbackOpen(false),
                    atlassianAccountId: feedbackCollectorProperties.userId,
                    name: feedbackCollectorProperties.displayName,
                    entrypointId: feedbackCollectorProperties.entrypointId,
                    summaryPlaceholder: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackSummaryPlaceholder),
                    additionalFields: [
                        {
                            id: feedbackCollectorProperties.feedbackContextId,
                            value: feedbackContextString
                        }
                    ],
                    feedbackTitle: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackTitle),
                    showTypeField: false,
                    customTextAreaLabel: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackSummaryTitle),
                    canBeContactedLabel: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$CanContactLabel, {}),
                    enrolInResearchLabel: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$EnrolLabel, {})
                })
            ]
        })
    });
};
module.exports["AIFeedbackComponent"] = $00b0d3bf57a2c2c6$export$f9f34317e5bc3551;

});

parcelRegister("aFwxm", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9FnLD = parcelRequire("9FnLD");

const $321f16821ba8d88a$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
module.exports["ThumbIcon"] = $321f16821ba8d88a$export$ec2ba0e929740f73;

});

parcelRegister("fXbFR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PxT5 = parcelRequire("4PxT5");

const $d2d9cd8fe7c899bb$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $4PxT5.useOnScreen)(ref);
    const dwellTimeRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $d2d9cd8fe7c899bb$export$15dda63faa44a0df;

});

parcelRegister("4PxT5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $944e21aa736984a5$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $944e21aa736984a5$export$edb9b52ab3f1abbb;

});

parcelRegister("kt1Xc", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $2UyBL = parcelRequire("2UyBL");

parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $9Rf00 = parcelRequire("9Rf00");


var $in8wv = parcelRequire("in8wv");

const $45557925e309956a$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $45557925e309956a$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $irOoi.usePreloadedQuery)((0, $2UyBL.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $in8wv.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        renderAsMarkdown: !!aiSnippetText
    });
    if ((0, $dh538.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9Rf00.AIFeedbackPropertiesProvider), {
        entrypointId: $45557925e309956a$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name,
        children: content
    });
    return content;
};
module.exports["AISnippetLoader"] = $45557925e309956a$export$f50b64530422ea99;

});

parcelRegister("2UyBL", function(module, exports) {
/**
 * @generated SignedSource<<83c7dc86ba34b94d5c11c0df299d770d>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $06d2529594a8e25b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$06d2529594a8e25b$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $06d2529594a8e25b$export$2e2bcd8739ae039 = $06d2529594a8e25b$var$node;
module.exports["default"] = $06d2529594a8e25b$export$2e2bcd8739ae039;

});


//# sourceMappingURL=CommentsPanelWrapper.3eb8f2be.js.map
